import { vehicleService } from "../../helpers/vehicleService";

export const state = {
  getShowUserVehicle: [],
  getAllUserVehicle: [],
  getShowVehicleMake: [],
  getShowChargerType: [],
  getShowBatterySize: [],
  getShowVehicleModel: [],
  getUpdateStatus: [],
  getAllMake: [],
  getAllType: [],
  getAllSize: [],
  getAllModel: [],
  getAllVehicleMake: [],
  getAllChargerType: [],
  getAllTypes: [],
  getAllBatterySize: [],
  getAllVehicleModel: [],
  userVehicleCount: "",
  vehicleMakeCount: "",
  batterySizeCount: "",
  vehicleModelCount: "",
  chargerTypeCount: "",
  paginations: {},
  loading: true,
};

export const mutations = {
  getShowUserVehicle(state, payload) {
    state.getShowUserVehicle = payload.result;
    state.loading = false;
  },
  getAllUserVehicle(state, payload) {
    state.getAllUserVehicle = payload.result.data;
    state.loading = false;
    state.paginations = payload.result;
    state.userVehicleCount = payload.result.total;
  },
  getShowVehicleMake(state, payload) {
    state.getShowVehicleMake = payload.result;
    state.loading = false;
  },
  getShowChargerType(state, payload) {
    state.getShowChargerType = payload.result;
    state.loading = false;
  },
  getShowBatterySize(state, payload) {
    state.getShowBatterySize = payload.result;
    state.loading = false;
  },
  getShowVehicleModel(state, payload) {
    state.getShowVehicleModel = payload.result;
    state.loading = false;
  },
  getMake(state, payload) {
    state.getAllMake = payload.result;
    state.loading = false;
  },
  getAllModel(state, payload) {
    if (payload.code == 200) {
      state.getAllModel = payload.result;
    } else {
      state.getAllModel = [];
    }
    state.loading = false;
  },
  getType(state, payload) {
    state.getAllType = payload.result;
    state.loading = false;
  },
  getSize(state, payload) {
    console.log(payload.result);
    state.getAllSize = payload.result ? payload.result : [];
    state.loading = false;
  },
  getModel(state, payload) {
    if (payload.code == 200) {
      state.getAllModel = payload.result;
    } else {
      state.getAllModel = [];
    }
    state.loading = false;
  },
  getChargerType(state, payload) {
    state.getAllTypes = payload.result;
    state.loading = false;
  },
  getUserVehicleModel(state, payload) {
    console.log(state);
    console.log(payload);
  },
  getUpdateStatus(state, payload) {
    state.getUpdateStatus = payload;
  },
  getAllVehicleMake(state, payload) {
    state.getAllVehicleMake = payload.result.data;
    state.loading = false;
    state.paginations = payload.result;
    state.vehicleMakeCount = payload.result.total;
  },
  getAllChargerType(state, payload) {
    state.getAllChargerType = payload.result.data;
    state.loading = false;
    state.paginations = payload.result;
    state.chargerTypeCount = payload.result.total;
  },
  getAllBatterySize(state, payload) {
    state.getAllBatterySize = payload.result.data;
    state.loading = false;
    state.paginations = payload.result;
    state.batterySizeCount = payload.result.total;
  },
  getAllVehicleModel(state, payload) {
    state.getAllVehicleModel = payload.result.data;
    state.loading = false;
    state.paginations = payload.result;
    state.vehicleModelCount = payload.result.total;
  },
  getUserVehicleListRequest(state) {
    state.loading = true;
  },
  getVehicleMakeListRequest(state) {
    state.loading = true;
  },
  getChargerTypeListRequest(state) {
    state.loading = true;
  },
  getUserVehicle(state, payload) {
    state.user = payload.result;
  },
  getUserVehicleListFailure(state) {
    state.loading = false;
  },
  getVehicleMakeListFailure(state) {
    state.loading = false;
  },
  getUpdateVehicleMakeFailure(state) {
    state.loading = false;
  },
};

export const actions = {
  async getUserVehicle({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getUserVehicleListRequest");
    await vehicleService.getUserVehicle(data).then(
      (response) => {
        commit("getAllUserVehicle", response.data);
      },
      (error) => {
        commit("getUserVehicleListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async getVehicleMake({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await vehicleService.getVehicleMake(data).then(
      (response) => {
        commit("getAllVehicleMake", response.data);
      },
      (error) => {
        commit("getVehicleMakeListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async getChargerType({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getChargerTypeListRequest");
    await vehicleService.getChargerType(data).then(
      (response) => {
        commit("getAllChargerType", response.data);
      },
      (error) => {
        commit("getVehicleMakeListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async getBatterySize({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getChargerTypeListRequest");
    await vehicleService.getBatterySize(data).then(
      (response) => {
        commit("getAllBatterySize", response.data);
      },
      (error) => {
        commit("getVehicleMakeListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async getVehicleModel({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    commit("getVehicleMakeListRequest");
    await vehicleService.getVehicleModel(data).then(
      (response) => {
        commit("getAllVehicleModel", response.data);
      },
      (error) => {
        commit("getVehicleMakeListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async showVehicleMake({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await vehicleService.showVehicleMake(data).then(
      (response) => {
        commit("getShowVehicleMake", response.data);
      },
      (error) => {
        commit("getVehicleMakeListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async showChargerType({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getChargerTypeListRequest");
    await vehicleService.showChargerType(data).then(
      (response) => {
        commit("getShowChargerType", response.data);
      },
      (error) => {
        commit("getVehicleMakeListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async showBatterySize({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getChargerTypeListRequest");
    await vehicleService.showBatterySize(data).then(
      (response) => {
        commit("getShowBatterySize", response.data);
      },
      (error) => {
        commit("getVehicleMakeListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async showVehicleModel({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await vehicleService.showVehicleModel(data).then(
      (response) => {
        commit("getShowVehicleModel", response.data);
      },
      (error) => {
        commit("getVehicleMakeListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async updateVehicleMake({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await vehicleService.updateVehicleMake(data).then((response) => {
      if (response.data.code == 200) {
        dispatch("alert/success", response.data.msg, { root: true });
        commit("getUpdateStatus", response.data.code);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async updateChargerType({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await vehicleService.updateChargerType(data).then((response) => {
      if (response.data.code == 200) {
        dispatch("alert/success", response.data.msg, { root: true });
        commit("getUpdateStatus", response.data.code);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async updateBatterySize({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await vehicleService.updateBatterySize(data).then((response) => {
      if (response.data.code == 200) {
        dispatch("alert/success", response.data.msg, { root: true });
        commit("getUpdateStatus", response.data.code);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async updateVehicleModel({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await vehicleService.updateVehicleModel(data).then((response) => {
      if (response.data.code == 200) {
        dispatch("alert/success", response.data.msg, { root: true });
        commit("getUpdateStatus", response.data.code);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async createVehicleMake({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await vehicleService.addVehicleMake(data).then((response) => {
      if (response.data.code == 200) {
        dispatch("alert/success", response.data.msg, { root: true });
        commit("getUpdateStatus", response.data.code);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async createChargerType({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getChargerTypeListRequest");
    await vehicleService.addChargerType(data).then((response) => {
      if (response.data.code == 200) {
        dispatch("alert/success", response.data.msg, { root: true });
        commit("getUpdateStatus", response.data.code);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async createBatterySize({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getChargerTypeListRequest");
    await vehicleService.addBatterySize(data).then((response) => {
      if (response.data.code == 200) {
        dispatch("alert/success", response.data.msg, { root: true });
        commit("getUpdateStatus", response.data.code);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async createVehicleModel({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await vehicleService.addVehicleModel(data).then((response) => {
      if (response.data.code == 200) {
        dispatch("alert/success", response.data.msg, { root: true });
        commit("getUpdateStatus", response.data.code);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async deleteVehicleMake({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await vehicleService.deleteVehicleMake(data).then((response) => {
      if (response.data.code == 200) {
        dispatch("alert/success", response.data.msg, { root: true });
        commit("getUpdateStatus", response.data.code);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async deleteChargerType({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await vehicleService.deleteChargerType(data).then((response) => {
      if (response.data.code == 200) {
        dispatch("alert/success", response.data.msg, { root: true });
        commit("getUpdateStatus", response.data.code);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async deleteBatterySize({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await vehicleService.deleteBatterySize(data).then((response) => {
      if (response.data.code == 200) {
        dispatch("alert/success", response.data.msg, { root: true });
        commit("getUpdateStatus", response.data.code);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async deleteVehicleModel({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await vehicleService.deleteVehicleModel(data).then((response) => {
      if (response.data.code == 200) {
        dispatch("alert/success", response.data.msg, { root: true });
        commit("getUpdateStatus", response.data.code);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async getMake({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await vehicleService.getMakeVehicles(data).then((response) => {
      if (response.data.code == 200) {
        commit("getMake", response.data);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async getModelList({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await vehicleService.getAllModelVehicles(data).then((response) => {
      if (response.data.code == 200) {
        commit("getModel", response.data);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async getTypeList({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await vehicleService.getAllChargerTypes(data).then((response) => {
      if (response.data.code == 200) {
        commit("getChargerType", response.data);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async getType({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await vehicleService.getChargerTypes(data).then((response) => {
      if (response.data.code == 200) {
        commit("getType", response.data);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async getSize({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await vehicleService.getBatterySizes(data).then((response) => {
      if (response.data.code == 200) {
        commit("getSize", response.data);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async getModel({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    commit("getVehicleMakeListRequest");
    await vehicleService.getModelVehicles(data).then((response) => {
      if (response.data) {
        commit("getModel", response.data);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async addOrUpdateVehcile({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    commit("getVehicleMakeListRequest");
    await vehicleService.addOrUpdateUserVehicle(data).then((response) => {
      if (response.data.code == 200) {
        dispatch("alert/success", response.data.msg, { root: true });
        commit("getUpdateStatus", response.data.code);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },

  async showUserVehicle({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await vehicleService.showUserVehicle(data).then(
      (response) => {
        commit("getShowUserVehicle", response.data);
      },
      (error) => {
        commit("getVehicleMakeListFailure", error, { root: true });
        dispatch("alert/error", error, { root: true });
      }
    );
  },

  async deleteUserVehicle({ dispatch, commit }, data) {
    let token = JSON.parse(localStorage.getItem("token"));
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    commit("getVehicleMakeListRequest");
    await vehicleService.deleteUserVehicle(data).then((response) => {
      if (response.data.code == 200) {
        dispatch("alert/success", response.data.msg, { root: true });
        commit("getUpdateStatus", response.data.code);
      } else {
        commit("getUpdateVehicleMakeFailure", response.data);
        dispatch("alert/error", response.data.msg, { root: true });
      }
    });
  },
};
export const getters = {
  loading: (state) => state.loading,
  getAllUserVehicle: (state) => state.getAllUserVehicle,
  getAllVehicleMake: (state) => state.getAllVehicleMake,
  getAllChargerType: (state) => state.getAllChargerType,
  getAllTypes: (state) => state.getAllTypes,
  getAllBatterySize: (state) => state.getAllBatterySize,
  getAllVehicleModel: (state) => state.getAllVehicleModel,
  getShowVehicleMake: (state) => state.getShowVehicleMake,
  getShowChargerType: (state) => state.getShowChargerType,
  getShowBatterySize: (state) => state.getShowBatterySize,
  getShowVehicleModel: (state) => state.getShowVehicleModel,
  getUpdateStatus: (state) => state.getUpdateStatus,
  userVehicleCount: (state) => state.userVehicleCount,
  vehicleMakeCount: (state) => state.vehicleMakeCount,
  vehicleModelCount: (state) => state.vehicleModelCount,
  batterySizeCount: (state) => state.batterySizeCount,
  chargerTypeCount: (state) => state.chargerTypeCount,
  getAllMake: (state) => state.getAllMake,
  getAllType: (state) => state.getAllType,
  getAllSize: (state) => state.getAllSize,
  getAllModel: (state) => state.getAllModel,
  chargingHistoryData: (state) => state.getUserVehicle,
  pagination: (state) => state.paginations,
  getShowUserVehicle: (state) => state.getShowUserVehicle,
};
